import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FixedSlideNav from '../../../../components/navbar/FixedSlideNav'
import { links } from '../../../../quality/constants/StationsConstants'
import { DASHBOARD } from '../../../constants/InstallationConstants'
import { Outlet } from 'react-router-dom'
import HomeAction from 'home/actions/HomeAction'
import BoundaryError from 'log/components/BoundaryError'
import { connect } from 'react-redux'
import { Box } from '@mui/material'

class InstallationsApp extends Component {
    componentDidMount() {
        this.props.setHelpLink('', '')
    }

    getLink = (linkName) => {
        if (links[linkName].href) {
            return links[linkName]
        }
        return {
            ...links[linkName],
            href: `/installation/${linkName}`,
        }
    }

    render() {
        const navBarLinks = [DASHBOARD, 'territoryActivities', 'campaign', 'installationOptions', 'counter'].map(linkName => this.getLink(linkName))

        return (
            <div>
                <FixedSlideNav links={navBarLinks}/>
                <main>
                    <div className='content-page fullscreen'>
                        <BoundaryError>
                            <Box sx={{ padding: '10px' }}>
                                <Outlet />
                            </Box>
                        </BoundaryError>
                    </div>
                </main>
            </div>
        )
    }
}

InstallationsApp.defaultProps = {
    getLink: ('', ''),
}


InstallationsApp.propTypes = {
    children: PropTypes.element,
    getLink: PropTypes.func,
    setHelpLink: PropTypes.func,
}

const mapDispatchToProps = {
    setHelpLink: HomeAction.setHelpLink,
}

export default connect(null, mapDispatchToProps)(InstallationsApp)
